<template>
  <!-- down arrow  -->
  <svg
    viewBox="0 0 25 25"
    :class="classValue"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        d="M17 10.5L12.5 15L8 10.5"
        stroke="#121923"
        stroke-width="1.2"
      ></path>
    </g>
  </svg>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    classValue: {
      type: String,
    },
  },
};
</script>
